module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-broker-list.1a7be75a.png";